import { motion, AnimatePresence } from 'framer-motion';
import { useChatApi } from '../Services/ChatApiProvider';
import { channelImageSrc } from '../Services/mediaUrl';
import assistantAvatar1 from '../media/assist1.jpg';
import assistantAvatar2 from '../media/assist2.jpg';

const ChatAvatars = ({ isChatActive, chatType }) => {
  const { channelSettings } = useChatApi();
  const widgetIconImage = channelImageSrc(channelSettings, 'widgetIcon');
  const aiAssistantImage = channelImageSrc(channelSettings, 'AIassistantImage');
  const liveAssistantImage = channelImageSrc(channelSettings, 'liveAssistantImage');
  const secondLiveAssistantImage = channelImageSrc(channelSettings, 'secondLiveAssistantImage');
  const liveAvatarSrc = liveAssistantImage ? liveAssistantImage : assistantAvatar1;
  const secondLiveAvatarSrc = secondLiveAssistantImage
    ? secondLiveAssistantImage
    : assistantAvatar2;

  const avatars = widgetIconImage ? (
    <div className="widget-icon">
      <img src={widgetIconImage} alt="Widget icon" />
    </div>
  ) : (
    <>
      <div className="avatar avatar1">
        <img src={liveAvatarSrc} alt="Assistant 1" />
      </div>
      <div className="avatar avatar-next">
        <img src={secondLiveAvatarSrc} alt="Assistant 2" />
      </div>
      <div
        className={`avatar avatar-next bot ${aiAssistantImage ? 'has-ai-avatar' : ''}`}
        style={aiAssistantImage ? { backgroundImage: `url("${aiAssistantImage}")` } : undefined}
      ></div>
    </>
  );

  return (
    <AnimatePresence>
      {!isChatActive && (
        <motion.div
          className="chat-avatars"
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.2, ease: 'easeInOut' }}
        >
          {avatars}
        </motion.div>
      )}

      {isChatActive && chatType === 'static-box' && (
        <motion.div
          className="chat-avatars"
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.2, ease: 'easeInOut' }}
        >
          {avatars}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ChatAvatars;
